import { paginatedIndexRouteOptions } from './paginatedIndexQuery';

/**
 * Route helper utilities for Articles.
 *
 * Articles are a single global resource. Each record has a site_context,
 * but CRUD lives exclusively under /admin/aktualnosci. The siteContext
 * argument is kept for call-site compatibility but ignored.
 */
export function createArticleRouteHelper(_siteContext, routes) {
  return {
    index: (extra) => routes.admin_articles(paginatedIndexRouteOptions(extra)),
    new: () => routes.new_admin_article(),
    edit: (id) => routes.edit_admin_article(id, paginatedIndexRouteOptions()),
    update: (id) => routes.admin_article(id, paginatedIndexRouteOptions()),
    destroy: (id) => routes.admin_article(id, paginatedIndexRouteOptions()),
  };
}
